import React from 'react';
import Nav from './components/Nav';
import './index.css';
import './Layout.css';
import { motion } from 'framer-motion';

export default class NotFound extends React.Component {
    render() {
        return (
            <>
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ delay: 0.25, ease:"easeIn" }}
                >
                    <h1 className="notfound">404<br />Not<br /> Found...＞_＜</h1>
                    <Nav />
                </motion.div>
            </>
        )
    }
};
